/**
 * Class for tracking the window size
 * @class
 */
class WindowTracer {
  constructor() {
    this.width = null;
    this.height = null;

    this.lastChange = null;

    // Bind `this` to event listeners
    this.resize = this._resize.bind(this);

    this._initialized = false;
  }

  /**
   * Callback for resize event
   */
  _resize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.lastChange = Date.now();
  }

  /**
   * Remove all event listeners
   */
  kill() {
    if (this._initialized) {
      window.removeEventListener('resize', this.resize);
    }
  }

  /**
   * Initialize all event listeners
   */
  init() {
    if (!this._initialized) {
      window.addEventListener('resize', this.resize);
      this._resize();
    }
  }
}

export default WindowTracer;
